export enum SecondaryCodesTableColumnsIdEnum {
    TIME_STOP = "start_date",
    TIME_RESTART = "end_date",
    DURATION = "duration",
    AREA = "area_name",
    MACHINE_CENTER = "machine_center_short_name",
    FUNCTIONAL_LOCATION = "functional_location_name",
    FAILURE_TYPE = "failure_type_name",
    FAILURE_CODE = "failure_code_name",
    SECONDARY_FAILURE_CODE = "secondary_failure_code",
    EDITION_OPTIONS = "edition_options",
}

export interface IEditionSecondaryCodes {
    edit: boolean;
    id: number;
    location_specific: boolean;
    changes?: {
        secondary_failure_code_id?: number;
        edited_by_user_id?: number;
        area_id?: number;
        functional_location_id?: number;
        failure_type_id?: number;
        failure_code_id?: number;
    };
}
